import { Facebook, Instagram, Linkedin, Crown } from "lucide-react";
import { Link } from "react-router-dom";
import GlobalFooter from "./GlobalFooter";

const seoCategories = [
  {
    title: "Komedia i Rozrywka",
    links: [
      { label: "Stand-up Comedy", slug: "stand-up-comedy" },
      { label: "Kabaret", slug: "kabaret" },
      { label: "Teatr Improwizacji", slug: "teatr-improwizacji" },
      { label: "Mimowie", slug: "mimowie" },
      { label: "Poetry Slam", slug: "poetry-slam" },
    ],
  },
  {
    title: "Muzyka na Żywo",
    links: [
      { label: "Muzyka na Żywo", slug: "muzyka-na-zywo" },
      { label: "DJ i Wodzirej", slug: "dj-i-wodzirej" },
      { label: "Występy Wokalne", slug: "wystepy-wokalne" },
      { label: "Występy Jazzowe", slug: "wystepy-jazzowe" },
      { label: "Występy Orkiestrowe", slug: "wystepy-orkiestrowe" },
      { label: "Występy Chóralne", slug: "wystepy-choralne" },
      { label: "Występy Operowe", slug: "wystepy-operowe" },
      { label: "Występy Beatboxerów", slug: "wystepy-beatboxerow" },
    ],
  },
  {
    title: "Instrumenty Solo",
    links: [
      { label: "Występy Skrzypcowe", slug: "wystepy-skrzypcowe" },
      { label: "Występy Gitarowe", slug: "wystepy-gitarowe" },
      { label: "Występy Saksofonu", slug: "wystepy-saksofonu" },
      { label: "Występy Harfowe", slug: "wystepy-harfowe" },
      { label: "Występy Perkusyjne", slug: "wystepy-perkusyjne" },
      { label: "Występy Akordeonowe", slug: "wystepy-akordeonowe" },
      { label: "Występy Wiolonczeli", slug: "wystepy-wiolonczele" },
      { label: "Występy Fletowe", slug: "wystepy-fletowe" },
      { label: "Występy Trąbki", slug: "wystepy-trabki" },
      { label: "Występy Kontrabasu", slug: "wystepy-kontrabasu" },
    ],
  },
  {
    title: "Pokazy Wizualne",
    links: [
      { label: "Pokazy Świetlne", slug: "pokazy-swietlne" },
      { label: "Pokazy Laserowe", slug: "pokazy-laserowe" },
      { label: "Pokazy Iluminacji", slug: "pokazy-iluminacji" },
      { label: "Pokazy Multimedialne", slug: "pokazy-multimedialne" },
      { label: "Pokazy Pirotechniczne", slug: "pokazy-pirotechniczne" },
      { label: "Pokazy Sztuki Cyfrowej", slug: "pokazy-sztuki-cyfrowej" },
      { label: "Pokazy Sztuki Kinetycznej", slug: "pokazy-sztuki-kinetycznej" },
      { label: "Pokazy Sztuki Światła", slug: "pokazy-sztuki-swiatla" },
    ],
  },
  {
    title: "Akrobatyka i Taniec",
    links: [
      { label: "Pokazy Taneczne", slug: "pokazy-taneczne" },
      { label: "Akrobaci", slug: "akrobaci" },
      { label: "Fireshow", slug: "fireshow" },
      { label: "Żonglerzy", slug: "zonglerzy" },
      { label: "Żonglerka Ogniem", slug: "pokazy-zonglerki-ogniem" },
      { label: "Występy Folklorystyczne", slug: "wystepy-folklorystyczne" },
    ],
  },
  {
    title: "Magia i Iluzja",
    links: [
      { label: "Iluzjonista", slug: "iluzjonista" },
      { label: "Teatr Cieni", slug: "teatr-cieni" },
      { label: "Bubble Show", slug: "bubble-show" },
      { label: "Sztuczki Karciane", slug: "pokazy-sztuczek-karcianych" },
    ],
  },
  {
    title: "Sztuka i Warsztaty",
    links: [
      { label: "Karykaturzysta", slug: "karykaturzysta" },
      { label: "Warsztaty Artystyczne", slug: "warsztaty-artystyczne" },
      { label: "Pokazy Bodypainting", slug: "pokazy-bodypainting" },
      { label: "Pokazy Origami", slug: "pokazy-origami" },
      { label: "Pokazy Kaligrafii", slug: "pokazy-kaligrafii" },
      { label: "Pokazy Garncarskie", slug: "pokazy-garncarskie" },
      { label: "Pokazy Rzeźbiarskie", slug: "pokazy-rzezbiarskie" },
      { label: "Sztuka Uliczna", slug: "pokazy-sztuki-ulicznej" },
      { label: "Sztuka Papierowa", slug: "pokazy-sztuki-papierowej" },
      { label: "Sztuka Recyklingu", slug: "pokazy-sztuki-recyklingu" },
    ],
  },
  {
    title: "Pokazy Tematyczne",
    links: [
      { label: "Pokazy Barmańskie", slug: "pokazy-barmanskie" },
      { label: "Pokazy Kulinarne", slug: "pokazy-kulinarne" },
      { label: "Pokazy Naukowe", slug: "pokazy-naukowe" },
      { label: "Pokazy Robotyki", slug: "pokazy-robotyki" },
      { label: "Pokazy Ekologiczne", slug: "pokazy-ekologiczne" },
      { label: "Pokazy Mody", slug: "pokazy-mody" },
    ],
  },
];

export const Footer = () => {
  const scrollToSection = (id: string) => {
    if (window.location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <footer className="bg-primary-dark text-white py-16 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <a href="/" className="flex items-center gap-2 mb-4">
              <Crown className="w-6 h-6 text-accent" />
              <span className="font-montserrat font-bold text-lg">WystepFirmowy<span className="text-accent">.pl</span></span>
            </a>
            <p className="text-white/40 text-sm leading-relaxed">
              Profesjonalne występy artystyczne i komediowe,
              które urozmaicą każde wydarzenie firmowe.
            </p>
          </div>
          <div>
            <h4 className="font-montserrat font-bold text-sm tracking-widest uppercase text-white/60 mb-4">Menu</h4>
            <div className="space-y-2">
              <button onClick={() => scrollToSection("about")} className="block text-white/40 text-sm hover:text-accent transition-colors">O nas</button>
              <button onClick={() => scrollToSection("offer")} className="block text-white/40 text-sm hover:text-accent transition-colors">Oferta</button>
              <button onClick={() => scrollToSection("benefits")} className="block text-white/40 text-sm hover:text-accent transition-colors">Dlaczego warto?</button>
              <button onClick={() => scrollToSection("why-us")} className="block text-white/40 text-sm hover:text-accent transition-colors">Dlaczego my?</button>
              <button onClick={() => scrollToSection("kontakt")} className="block text-white/40 text-sm hover:text-accent transition-colors">Kontakt</button>
            </div>
          </div>
          <div>
            <h4 className="font-montserrat font-bold text-sm tracking-widest uppercase text-white/60 mb-4">Prawne</h4>
            <div className="space-y-2">
              <Link to="/rodo" className="block text-white/40 text-sm hover:text-accent transition-colors">Obowiązek informacyjny RODO</Link>
              <Link to="/polityka-prywatnosci" className="block text-white/40 text-sm hover:text-accent transition-colors">Polityka prywatności</Link>
              <Link to="/regulamin" className="block text-white/40 text-sm hover:text-accent transition-colors">Regulamin serwisu</Link>
            </div>
          </div>
          <div>
            <h4 className="font-montserrat font-bold text-sm tracking-widest uppercase text-white/60 mb-4">Kontakt</h4>
            <div className="space-y-2">
              <p className="text-white/40 text-sm">
                <a href="mailto:kontakt@wystepfirmowy.pl" className="hover:text-accent transition-colors">kontakt@wystepfirmowy.pl</a>
              </p>
              <p className="text-white/40 text-sm">
                <a href="tel:+48533333993" className="hover:text-accent transition-colors">+48 533 333 993</a>
              </p>
              <div className="flex gap-3 mt-4">
                {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                  <a key={i} href="#" className="w-10 h-10 rounded-xl bg-white/5 hover:bg-accent/20 flex items-center justify-center transition-all hover:scale-110">
                    <Icon size={18} className="text-white/50 hover:text-accent" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* SEO Subpages */}
        <div className="mt-16 pt-12 border-t border-white/5">
          <h3 className="font-montserrat font-bold text-sm tracking-widest uppercase text-white/60 mb-8 text-center">Nasze atrakcje na wydarzenia firmowe</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-x-6 gap-y-8">
            {seoCategories.map((category) => (
              <div key={category.title}>
                <h4 className="font-montserrat font-semibold text-xs tracking-wider uppercase text-white/50 mb-3">{category.title}</h4>
                <div className="space-y-1.5">
                  {category.links.map((link) => (
                    <Link
                      key={link.slug}
                      to={`/atrakcje/${link.slug}`}
                      className="block text-white/30 text-xs hover:text-accent transition-colors leading-relaxed"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <GlobalFooter />
      </div>
    </footer>
  );
};
